"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import * as Aria from 'react-aria-components';
import { useObjectRef } from '@react-aria/utils';
import '../../../lib/propsContext/propsContext.mjs';
import '../../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../../lib/propsContext/PropsContextProvider.mjs';
import styles from './FileInput.module.scss.mjs';

const FileInput = (props) => {
  const { children, isDisabled, onChange, ref } = props;
  const inputRef = useObjectRef(ref);
  const handlePress = () => {
    if (inputRef.current?.value) {
      inputRef.current.value = "";
      onChange?.(null);
    }
    inputRef.current?.click();
  };
  const handleChange = (event) => {
    onChange?.(event.target.files);
  };
  const propsContext = {
    Button: {
      onPress: handlePress,
      className: styles.trigger,
      isDisabled
    }
  };
  return /* @__PURE__ */ jsxs(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: [
    children,
    /* @__PURE__ */ jsx(
      Aria.Input,
      {
        style: { display: "none" },
        type: "file",
        ref: inputRef,
        onChange: handleChange
      }
    )
  ] });
};

export { FileInput };
//# sourceMappingURL=FileInput.mjs.map
